import { http } from "@/http";

class GeoreferencingService {
  async getHistory(imei) {
    return await http.get(
      `/basestation-service/georeferencing-history/${imei}/history`
    );
  }
}

export default new GeoreferencingService();
